export const TextFonts = "Inter";
export const CodeFonts = "Roboto Mono";
